import React from 'react';
import '../../styles/buttons.css';

const PHONE = (
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129" fill="none">
<circle cx="64.2366" cy="64.2337" r="38.9879" fill="white" stroke="white" stroke-width="10.3901"/>
<circle cx="64.232" cy="64.2307" r="39.7044" fill="#1A160F" stroke="white" stroke-width="1.33932"/>
<path d="M77.9253 86.3478C79.9479 86.3323 81.7689 85.9093 83.0337 85.1173L83.2788 84.9542C86.2815 82.8273 87.3929 81.2623 87.5698 79.3829L87.5933 79.0031C87.5926 78.5346 87.5619 78.2122 87.4644 77.9298C87.3693 77.655 87.1964 77.3791 86.8462 77.0402C86.2967 76.5084 85.3771 75.8807 83.8149 74.924L82.0278 73.8488C78.8292 71.9432 76.9633 70.9817 75.5464 70.7062C74.8615 70.573 74.2903 70.6033 73.7241 70.7697C73.2905 70.8971 72.8465 71.1082 72.3442 71.4083L71.8208 71.7384C70.9862 72.3002 70.2383 72.73 69.4907 72.9298C68.7153 73.137 67.9672 73.0903 67.1528 72.7579C66.3604 72.4344 65.5119 71.8434 64.5083 70.9855C63.7528 70.3396 62.891 69.5264 61.8794 68.5323L60.8159 67.4767C59.3271 65.9879 58.1675 64.7909 57.3062 63.7833C56.4484 62.7799 55.8582 61.9321 55.5347 61.1398C55.2022 60.3254 55.1546 59.5773 55.3618 58.8019C55.5616 58.0542 55.9923 57.3065 56.5542 56.4718V56.4708C57.035 55.7414 57.3533 55.149 57.5229 54.5763C57.6889 54.016 57.7194 53.452 57.5864 52.7716C57.3453 51.5382 56.5786 49.9561 55.1138 47.4132L54.4429 46.2628V46.2618C52.8366 43.5278 51.9928 42.1411 51.3013 41.4181C50.9741 41.0761 50.7055 40.9118 50.4282 40.8214C50.1353 40.726 49.7911 40.6993 49.2739 40.6993C48.5483 40.6994 47.9434 40.8472 47.2808 41.2238C46.6005 41.6104 45.8466 42.2442 44.8423 43.2482H44.8433C43.7311 44.394 43.1262 45.1358 42.7515 45.9464C42.4243 46.6544 42.2571 47.4475 42.1304 48.672L42.0786 49.2238C42.0137 50.2076 42.03 51.3789 42.1128 52.463C42.1965 53.5599 42.3451 54.5277 42.5298 55.1124L42.5288 55.1134C43.2498 57.2711 44.7834 59.9365 46.8608 62.8107C48.936 65.6817 51.5352 68.7329 54.3589 71.6534C60.0164 77.5049 66.5224 82.7775 71.4741 85.0392L71.4751 85.0382C73.4667 85.9198 75.778 86.3641 77.9253 86.3478Z" fill="white" stroke="white" stroke-width="1.03901"/>
</svg>
)

const ContactButton = () => {
  const handleScrollToContacts = () => {
    const contactSection = document.getElementById("contacts");
    if (contactSection) {
      const yOffset = -150; // при необходимости
      const y = contactSection.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  return (
    <div className="contact-btn-wrapper">
      <button className="contact-btn" onClick={handleScrollToContacts}>Связаться</button>
      <div className="contact-btn-icon">
        <div className="phone-icon">
          <div className="pulse-circle" />
          <div className="pulse-circle circle-2" />
          {PHONE}
        </div>
      </div>
    </div>
  );
};

export default ContactButton;
